import React from "react";
import { FileText } from "lucide-react";

export default function CRMQuotesTab() {
  return (
    <div data-testid="crm-quotes-tab" className="rounded-2xl border border-white/10 bg-black/25 p-8 text-center">
      <FileText size={22} className="mx-auto text-cyan mb-2" />
      <h3 className="font-serif text-2xl text-white">Quotes</h3>
      <div className="label-caps text-[10px] text-amber-300 tracking-widest mt-2">Phase 3</div>
      <p className="text-white/60 text-sm mt-3 max-w-lg mx-auto">
        Build cinematic quotes with vehicle, hours, add-ons, deposit and total. Send by email / SMS with one click, then convert straight into a booking.
      </p>
    </div>
  );
}
